(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[44],{

/***/ 99165:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dao/create",
      function () {
        return __webpack_require__(12530);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 12530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55351);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76699);
/* harmony import */ var _dao_dao_stateful__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63064);
/* harmony import */ var _dao_dao_stateless__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57572);
/* harmony import */ var _dao_dao_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62413);
// GNU AFFERO GENERAL PUBLIC LICENSE Version 3. Copyright (C) 2022 DAO DAO Contributors.
// See the "LICENSE" file in the root directory of this package for more copyright information.






var CreateDaoPage = function() {
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
                description: t("info.createADaoDescription"),
                openGraph: {
                    url: _dao_dao_utils__WEBPACK_IMPORTED_MODULE_4__/* .SITE_URL */ ._O + "/dao/create",
                    title: t("title.createADAO"),
                    description: t("info.createADaoDescription")
                },
                title: t("title.createADAO")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_dao_dao_stateful__WEBPACK_IMPORTED_MODULE_2__/* .SuspenseLoader */ .yI, {
                fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_dao_dao_stateless__WEBPACK_IMPORTED_MODULE_3__/* .PageLoader */ .wY3, {}),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_dao_dao_stateful__WEBPACK_IMPORTED_MODULE_2__/* .CreateDaoForm */ .Rt, {})
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (CreateDaoPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(99165); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);